import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import ApprovedHourItem from './ApprovedHourItem';

class TaskItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
          marginTop: '0px',
          name: this.props.task.name,
        }
    }

    componentWillMount = () => {
      this.fitTaskName(this.props.task.name);
    };

    // EVENT HANDLERS

    handleClick = () => {
        this.props.handleClick(this.props.id);
    };

    fitTaskName = (taskName) => {
      if (taskName.length > 80) {
        let index = taskName.substring(0,80).trim().lastIndexOf(' ');
        let newName = taskName.substring(0, index)  + '\n' + taskName.substring(index, taskName.length);
        this.setState({marginTop: '-15px', name: newName});
      }
    };

    // RENDER METHOD

    render = () => {

        if (this.props.active) {
        return (
            <div className="panel panel-default panel-pmtask"  style={{whiteSpace : "pre-line"}}>
                <div className="panel-heading" role="tab" id="headingOne-inner" >
                    {
                        this.props.showBadge && this.props.task.toApprove !== 0 ? <span className="label">{this.props.task.toApprove}</span> : null
                    }
                    <h4 className="panel-title">
                      <a style={{"cursor" : "pointer"}} onClick={this.handleClick} data-toggle="collapse" data-parent="#accordion-inner" aria-expanded="true" aria-controls="collapseOne">
                          <span className="acc" style={{borderColor : this.props.color}}><span className="md-expand-more" style={{"color" : this.props.color}}></span></span>
                          {this.state.name}
                          <span style={{textTransform : "none", marginTop: this.state.marginTop}} className="pull-right">
                              <span title="Hours logged and not yet submitted on task" style={{fontStyle : "italic"}}> { this.props.formattedHoursEntry } </span>
                              <span title="Hours submitted on task"> { this.props.formattedHoursSubmitted && this.props.formattedHoursEntry ? "|" : ""} { this.props.formattedHoursSubmitted } </span>
                              <span title="Hours approved on task">
                                  { this.props.formattedHoursApproved && (this.props.formattedHoursEntry || this.props.formattedHoursSubmitted) ? "|" : ""} { this.props.formattedHoursApproved } &nbsp;
                                  { this.props.task.toApprove === 0 ? <span className="md-done" /> : null }
                              </span>
                          </span>
                      </a>
                    </h4>
                </div>
                <div id="collapseOne-inner" className="panel-collapse" role="tabpanel" aria-labelledby="headingOne-inner">
                    <div className="panel-body">
                        <table className="table table-condensed project-people" style={{borderBottom: "1px solid #ddd"}}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th className="text-center">Hours</th>
                                    <th className="text-right">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.task.approvedHours.map((approvedHour, key) => {
                                        return <ApprovedHourItem
                                                   approvedBy={approvedHour.approvedBy}
                                                   approvedHoursID={approvedHour.aphID}
                                                   approvedHourKey={key}
                                                   approvable={approvedHour.approvable}
                                                   color={this.props.defaultColor}
                                                   date={this.props.date}
                                                   formattedRegularTimePrevRejected={approvedHour.formattedRegularTimePrevRejected}
                                                   formattedOvertimePrevRejected={approvedHour.formattedOvertimePrevRejected}
                                                   formattedRegularTime={approvedHour.formattedRegularTime}
                                                   formattedOvertime={approvedHour.formattedOvertime}
                                                   handleApprove={this.props.handleApprove}
                                                   handleReject={this.props.handleReject}
                                                   id={key}
                                                   key={key}
                                                   overtimeApproved={approvedHour.overtimeApproved}
                                                   overtimePrevRejected={approvedHour.overtimePrevRejected}
                                                   pmoApproved={approvedHour.pmoApproved}
                                                   projectNames={this.props.projectNames}
                                                   projectName={this.props.projectName}
                                                   projectKey={this.props.projectKey}
                                                   rejectedAt={approvedHour.rejectedAt}
                                                   rejectMessage={approvedHour.rejectMesssage}
                                                   shouldApprove={this.props.shouldApprove}
                                                   status={approvedHour.status}
                                                   task={this.props.task}
                                                   taskKey={this.props.taskKey}
                                                   timesheetID={approvedHour.timesheetID}
                                                   timeApproved={approvedHour.timeApproved}
                                                   timeOvertime={approvedHour.overtime}
                                                   timeTotal={approvedHour.regularTime}
                                                   timePrevRejected={approvedHour.timePrevRejected}
                                                   usersName={approvedHour.user}
                                                   />;
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
        } else {
            return (
            <div className="panel panel-default panel-pmtask" style={{whiteSpace : "pre-line"}}>
                <div className="panel-heading" role="tab" id="headingOne-inner">
                    {
                        this.props.showBadge && this.props.task.toApprove !== 0 ? <span className="label">{this.props.task.toApprove}</span> : null
                    }
                    <h4 className="panel-title">
                    <a style={{"cursor" : "pointer"}} onClick={this.handleClick} data-toggle="collapse" data-parent="#accordion-inner" aria-expanded="true" aria-controls="collapseOne">
                        <span className="acc" style={{borderColor : this.props.color}}>
                            <span className="md-chevron-right" style={{"color" : this.props.color}}>
                            </span>
                        </span>
                        {this.state.name}
                        <span style={{textTransform : "none", marginTop: this.state.marginTop}} className="pull-right">
                            <span title="Hours logged and not yet submitted on task" style={{fontStyle : "italic"}}> { this.props.formattedHoursEntry } </span>
                            <span title="Hours submitted on task"> { this.props.formattedHoursSubmitted && this.props.formattedHoursEntry ? "|" : ""} { this.props.formattedHoursSubmitted } </span>
                            <span title="Hours approved on task">
                                { this.props.formattedHoursApproved && (this.props.formattedHoursEntry || this.props.formattedHoursSubmitted) ? "|" : ""} { this.props.formattedHoursApproved } &nbsp;
                                { this.props.task.toApprove === 0 ? <span className="md-done" /> : null }
                            </span>
                        </span>
                    </a>
                    </h4>
                </div>
            </div>
            );
        }
    }
}

TaskItem.propTypes = {
    active: PropTypes.bool,
    color: PropTypes.string,
    currentUser: PropTypes.object,
    date: PropTypes.object,
    defaultColor: PropTypes.string,
    dispatch: PropTypes.func,
    formattedHoursApproved: PropTypes.string,
    formattedHoursEntry: PropTypes.string,
    formattedHoursSubmitted: PropTypes.string,
    handleApprove: PropTypes.func,
    handleClick: PropTypes.func,
    handleReject: PropTypes.func,
    id: PropTypes.number,
    projectKey: PropTypes.number,
    projectName: PropTypes.string,
    projectNames: PropTypes.array,
    shouldApprove: PropTypes.bool,
    showBadge: PropTypes.bool,
    task: PropTypes.object,
    taskKey: PropTypes.number
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaskItem);



/** WEBPACK FOOTER **
 ** ./src/app/components/TaskItem.js
 **/